import helper from 'helpers/steinerHelper';
    
export const actionTypes = helper.createActionTypes('WebReputationScore');
export const actions = helper.createActions('WebReputationScore', actionTypes);